import { render, staticRenderFns } from "./Add_new_fieldProject.vue?vue&type=template&id=3a781f24&scoped=true&"
import script from "./Add_new_fieldProject.vue?vue&type=script&lang=js&"
export * from "./Add_new_fieldProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a781f24",
  null
  
)

export default component.exports